import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  matCheckBox,
  matFunctions,
  matListAlt,
  matStar,
  matTextSnippet,
} from '@ng-icons/material-icons/baseline';
import { matInputOutline } from '@ng-icons/material-icons/outline';
import { Component, computed, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldTypeService } from '@core/services/field-type.service';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicField } from '@shared/components/dynamic-form/models/field';
import { ScoreFormatPipe } from '@shared/pipes/score-format.pipe';

@Component({
  selector: 'app-section-summary-field',
  imports: [NgIcon, ScoreFormatPipe, TranslateModule],
  viewProviders: [
    provideIcons({
      matCheckBox,
      matFunctions,
      matInputOutline,
      matListAlt,
      matStar,
      matTextSnippet,
    }),
  ],
  templateUrl: './section-summary-field.component.html',
})
export class SectionSummaryFieldComponent {
  field = input.required<DynamicField>();
  form = input.required<FormGroup>();
  inEditorMode = input<boolean>(false);

  fieldTypeService = inject(FieldTypeService);

  get score(): number {
    return this.form().get(this.field().key)?.value;
  }

  fieldType = computed(() => {
    return this.fieldTypeService.getFieldType(this.field().controlType);
  });
}
